<template>
  <div class="row">
    <div class="col-lg-12">
      <br />
      <div class="row">
        <div class="col-lg">
          <h4>
            Select Site:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="filter.site"
              @change="getCardData()"
            >
              <el-option
                v-for="option in filter.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 d-flex">
          <!-- asset summary -->
          <card>
            <div class="row text-left">
              <div class="col-lg">
                <h4 style="color: #99e6ff">Asset Summary</h4>
              </div>
            </div>
            <div class="row card-line" style="">
              <div class="col-lg"></div>
            </div>
            <br />
            <div
              class="row"
              style="
                border-radius: 10px;
                margin: 10px;
                padding: 10px;
                background-color: #1e1e29;
              "
            >
              <div class="col-lg text-center">
                <h1 style="font-size: 60px; color: #52de97">
                  {{ asset.active }}
                </h1>
                <p style="font-size: 15px">Active</p>
              </div>
            </div>
            <br />
            <div
              class="row"
              style="
                border-radius: 10px;
                margin: 10px;
                padding: 10px;
                background-color: #1e1e29;
              "
            >
              <div class="col-lg text-center">
                <h1 style="font-size: 60px; color: #ffcc00">
                  {{ asset.inactive }}
                </h1>
                <p style="font-size: 15px">Inactive</p>
              </div>
            </div>
            <br />
            <div
              class="row"
              style="
                border-radius: 10px;
                margin: 10px;
                padding: 10px;
                background-color: #1e1e29;
              "
            >
              <div class="col-lg text-center">
                <h1 style="font-size: 60px; color: #ea2127">
                  {{ asset.expired }}
                </h1>
                <p style="font-size: 15px">Expired</p>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-9">
          <!-- work order -->
          <div class="row">
            <div class="col-lg">
              <card>
                <div class="row">
                  <div class="col-lg-8 text-left">
                    <h4 style="color: #99e6ff">Total Number of Work Request</h4>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                  </div>

                  <div class="col-lg-4 text-right">
                    <p style="font-size: 15px">Total Work Request</p>
                    <h1 style="font-size: 30px; color: #52de97">
                      {{ workrequest.total }}
                    </h1>
                  </div>
                </div>

                <div class="row">
                  <!-- total number of work request -->
                  <div class="col-lg-4">
                    <div class="row text-center">
                      <div class="col-lg">
                        <p style="font-size: 15px">Open</p>
                        <pie-chart
                          v-if="open.loaded"
                          :chart-data="open.chartData"
                          :extra-options="open.extraOptions"
                          :height="150"
                        ></pie-chart>
                        <div
                          class="justify-content-center spinner"
                          v-if="!open.loaded"
                        >
                          <circle-8></circle-8>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row text-center">
                      <div class="col-lg">
                        <p style="font-size: 15px">{{ workrequest.open }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row text-center">
                      <div class="col-lg">
                        <p style="font-size: 15px">Cancel</p>
                        <pie-chart
                          v-if="cancel.loaded"
                          :chart-data="cancel.chartData"
                          :extra-options="cancel.extraOptions"
                          :height="150"
                        ></pie-chart>
                        <div
                          class="justify-content-center spinner"
                          v-if="!cancel.loaded"
                        >
                          <circle-8></circle-8>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row text-center">
                      <div class="col-lg">
                        <p style="font-size: 15px">{{ workrequest.cancel }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row text-center">
                      <div class="col-lg">
                        <p style="font-size: 15px">Close & Complete</p>
                        <pie-chart
                          v-if="closecomplete.loaded"
                          :chart-data="closecomplete.chartData"
                          :extra-options="closecomplete.extraOptions"
                          :height="150"
                        ></pie-chart>
                        <div
                          class="justify-content-center spinner"
                          v-if="!closecomplete.loaded"
                        >
                          <circle-8></circle-8>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row text-center">
                      <div class="col-lg">
                        <p style="font-size: 15px">
                          {{ workrequest.closecomplete }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <!-- non-preventive maintenance -->
              <div class="row">
                <div class="col-lg text-left">
                  <h4>Work Order Module for Non-preventive Maintenance</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <card>
                    <div class="row">
                      <div class="col-lg-6"></div>
                      <div class="col-lg-6 text-right">
                        <h1 style="color: #ffcc00">
                          {{ nonpreventivemaintenance.open }}
                        </h1>
                      </div>
                    </div>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                    <div class="row">
                      <!-- v-html="card.footerTotalAsset" -->
                      <div class="col-lg">
                        <div
                          class="footer-font"
                          slot="footer"
                          style="color: #99e6ff"
                        >
                          Open
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <card>
                    <div class="row">
                      <div class="col-lg-6"></div>
                      <div class="col-lg-6 text-right">
                        <h1 style="color: #ea2127">
                          {{ nonpreventivemaintenance.cancel }}
                        </h1>
                      </div>
                    </div>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                    <div class="row">
                      <!-- v-html="card.footerTotalAsset" -->
                      <div class="col-lg">
                        <div
                          class="footer-font"
                          slot="footer"
                          style="color: #99e6ff"
                        >
                          Cancel
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <card>
                    <div class="row">
                      <div class="col-lg-6"></div>
                      <div class="col-lg-6 text-right">
                        <h1 style="color: #52de97">
                          {{ nonpreventivemaintenance.closecomplete }}
                        </h1>
                      </div>
                    </div>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                    <div class="row">
                      <!-- v-html="card.footerTotalAsset" -->
                      <div class="col-lg">
                        <div
                          class="footer-font"
                          slot="footer"
                          style="color: #99e6ff"
                        >
                          Close & Cancel
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <!-- preventive maintenance -->
              <div class="row">
                <div class="col-lg text-left">
                  <h4>Work Order Module for Preventive Maintenance</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <card>
                    <div class="row">
                      <div class="col-lg-6"></div>
                      <div class="col-lg-6 text-right">
                        <h1 style="color: #ffcc00">
                          {{ preventivemaintenance.open }}
                        </h1>
                      </div>
                    </div>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                    <div class="row">
                      <!-- v-html="card.footerTotalAsset" -->
                      <div class="col-lg">
                        <div
                          class="footer-font"
                          slot="footer"
                          style="color: #99e6ff"
                        >
                          Open
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <card>
                    <div class="row">
                      <div class="col-lg-6"></div>
                      <div class="col-lg-6 text-right">
                        <h1 style="color: #ea2127">
                          {{ preventivemaintenance.cancel }}
                        </h1>
                      </div>
                    </div>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                    <div class="row">
                      <!-- v-html="card.footerTotalAsset" -->
                      <div class="col-lg">
                        <div
                          class="footer-font"
                          slot="footer"
                          style="color: #99e6ff"
                        >
                          Cancel
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <card>
                    <div class="row">
                      <div class="col-lg-6"></div>
                      <div class="col-lg-6 text-right">
                        <h1 style="color: #52de97">
                          {{ preventivemaintenance.closecomplete }}
                        </h1>
                      </div>
                    </div>
                    <div class="row card-line" style="">
                      <div class="col-lg"></div>
                    </div>
                    <div class="row">
                      <!-- v-html="card.footerTotalAsset" -->
                      <div class="col-lg">
                        <div
                          class="footer-font"
                          slot="footer"
                          style="color: #99e6ff"
                        >
                          Close & Cancel
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  TabPane,
  Tabs,
  Collapse,
  CollapseItem,
  BaseProgress,
  Modal,
  BaseSwitch,
  BaseCheckbox,
} from "src/components";
import { Table, TableColumn, DatePicker, Select, Option } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";
import BarChart from "@/components/Charts/BarChart";
import LineChart from "@/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";

import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  components: {
    Loading,
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    BaseProgress,
    PieChart,
    LineChart,
    BarChart,
    Modal,
    BaseSwitch,
    BaseCheckbox,
    Circle8,
  },
  data() {
    return {
      asset: {
        active: 14,
        inactive: 3,
        expired: 25,
      },
      workrequest: {
        total: 100,
        open: 15,
        cancel: 5,
        closecomplete: 80,
      },
      nonpreventivemaintenance: {
        open: 20,
        cancel: 14,
        closecomplete: 8,
      },
      preventivemaintenance: {
        open: 17,
        cancel: 10,
        closecomplete: 50,
      },
      open: {
        chartData: {
          labels: ["Open"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#ffcc00"],
              borderWidth: 0,
              data: [15, 85],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },
      cancel: {
        chartData: {
          labels: ["Cancel"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#EA2127"],
              borderWidth: 0,
              data: [15, 85],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },
      closecomplete: {
        chartData: {
          labels: ["Close % Complete"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#52de97"],
              borderWidth: 0,
              data: [15, 85],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },
      filter: {
        site: "",
        sites: [],
      },
    };
  },
  methods: {
    getCardData() {
      console.log("haihai");

      let start = moment().startOf("isoWeek").format("YYYY-MM-DD");
      let end = moment().endOf("isoWeek").format("YYYY-MM-DD");
      console.log(start, end);
      this.$http
        .get(
          ":9998/api/v1/analytics/cards?interval=yearly&from=" +
            start +
            "&to=" +
            end +
            "&site-id=" +
            this.filter.site
        )
        .then((res) => {
          console.log(res);
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.asset = {
              active: response.AssetSummary.Active,
              inactive: response.AssetSummary.Inactive,
              expired: response.AssetSummary.Expired,
            };

            this.workrequest = {
              total:
                parseInt(response.WorkRequest.Open) +
                parseInt(response.WorkRequest.Cancel) +
                parseInt(response.WorkRequest.CloseCompleted),
              open: response.WorkRequest.Open,
              cancel: response.WorkRequest.Cancel,
              closecomplete: response.WorkRequest.CloseCompleted,
            };

            this.open = {
              chartData: {
                labels: ["Open"],
                datasets: [
                  {
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    backgroundColor: ["#ffcc00"],
                    borderWidth: 0,
                    data: [
                      parseInt(response.WorkRequest.Open),
                      this.workrequest.total -
                        parseInt(response.WorkRequest.Open),
                    ],
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.pieChartOptions2,
            };
            this.cancel = {
              chartData: {
                labels: ["Cancel"],
                datasets: [
                  {
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    backgroundColor: ["#EA2127"],
                    borderWidth: 0,
                    data: [
                      parseInt(response.WorkRequest.Cancel),
                      this.workrequest.total -
                        parseInt(response.WorkRequest.Cancel),
                    ],
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.pieChartOptions2,
            };
            this.closecomplete = {
              chartData: {
                labels: ["Close % Complete"],
                datasets: [
                  {
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    backgroundColor: ["#52de97"],
                    borderWidth: 0,
                    data: [
                      parseInt(response.WorkRequest.CloseCompleted),
                      this.workrequest.total -
                        parseInt(response.WorkRequest.CloseCompleted),
                    ],
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.pieChartOptions2,
            };

            this.nonpreventivemaintenance = {
              open: response.WorkOrder.Open,
              cancel: response.WorkOrder.Cancel,
              closecomplete: response.WorkOrder.CloseCompleted,
            };
            this.preventivemaintenance = {
              open: response.PMWorkOrder.Open,
              cancel: response.PMWorkOrder.Cancel,
              closecomplete: response.PMWorkOrder.CloseCompleted,
            };
          }
        });
    },
    getSite() {
      this.filter.sites = [];

      this.$http.get(":9998/api/v1/setting/site").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].SiteName,
              value: response[i].SiteCode,
            };
            this.filter.sites.push(obj);
          }

          this.filter.site = this.filter.sites[0].value;
        }
      });
    },
  },
  created() {
    this.getSite();
    this.getCardData();
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    this.socket.close();
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 110%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
.spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.card-line {
  border-top: 0.5px solid #2b3553;
  margin: 5px;
}

.custom-card {
  height: 205px;
  padding-top: 5%;
}
</style>
